<template>
  <article>
    <h2>{{title}}のスタイルをご選択ください。</h2>
    <div>エンドパネル/カウンターの色柄は、扉と同色になります。</div>
    <template>
      <div class="colorPallet">
        <div>
          <img :src="selectColorStyle.colorStyleImage" />
        </div>
        <div class="style_list">
          <ul>
            <li v-for="(style,index) in styleList" :key="'style-' + index">
              <div class="radio">
                <input type="radio" :id="'style_' + index" name="style" @change="$emit('changeColorStyle', style)" :checked="style.colorStyleId===selectColorStyle.colorStyleId"/>
                <label :for="'style_' + index" class="radio-label">{{style.colorStyleName}}</label>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </template>
    <!-- <div class="mini_title" v-if="colorList.length > 0">
      <div v-if="isSelectedColor">{{color.name}}</div>
      <div v-else>カラーが選択されていません。</div>
    </div> -->
  </article>
</template>
<script>
import * as App from '../../../../../utils/App'

export default {
  name: 'menu',
  components: {
  },
  props: {
    title: String,
    styleList: Array,
    selectColorStyle: Object
  },
  data () {
    return {
    }
  },
  methods: {
    getImage: function (image) {
      return App.getMmstyleResource(image)
    }
  },
  computed: {
  },
  watch: {
  },
  mounted: function () {
  },
  created: function () {
  }
}
</script>
<style src="../../../../css/dc-customize.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/components/top/input/color/DcColorStyle.vue